import React from 'react';

const PaymentConfirmationModal = ({ isOpen, paymentId, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  // Closes the modal if clicked outside of the modal content
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modal}>
        <h2 style={styles.header}>Confirm Payment</h2>
        <p style={styles.message}>
          Are you sure you want to approve payment with ID: <strong>{paymentId}</strong>?
        </p>
        <div>
          <button style={styles.confirmButton} onClick={onConfirm}>Confirm</button>
          <button style={styles.cancelButton} onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    width: '400px',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
  },
  header: {
    fontSize: '20px',
    marginBottom: '10px',
  },
  message: {
    fontSize: '16px',
    marginBottom: '20px',
  },

  confirmButton: {
    padding: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: 'rgb(25, 42, 58)',
    color: 'white',
    cursor: 'pointer',
    width: '45%',
    transition: 'background-color 0.3s',
    margin:"0px!important"

  },
  cancelButton: {
    padding: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: 'rgb(179, 147, 89)',
    color: 'white',
    cursor: 'pointer',
    width: '45%',
    transition: 'background-color 0.3s',
    marginLeft: '10px',
  },
};

export default PaymentConfirmationModal;
